import Component from '../core/Component'

const STATES = {
    READY: 'is-ready'
}

export default class ShowIfRegion extends Component {
    prepare() {
        this.element.classList.add(STATES.READY)

        $(this.element).trigger('change:dom') // kvuli giant.show-if
    }
}
